export const toTableRowItems = (items: ReturoReport[]) =>
  items.map((item: ReturoReport) => ({
    id: item.id,
    noticeNumber: item.noticeNumber || '',
    cmrNumber: item.cmrNumber || '',
    truckNumber: item.truckNumber || '',
    driverName: item.driverName || '',
    createdBy: item.createdBy || '',
    created: item.created || '',
    shopName: item.shopName || '',
    providerName: item.providerName || '',
    status: item.status || '',
    idReturo: item.idReturo || ''
  }))

export const toShopItems = (items: ShopOption[]) =>
  items.map((item: ShopOption) => ({
      id: item.id,
      shopName: item.shopName,
      label: item.shopName + " (" + item.idReturo + ")",
      value: item.id,
      isChecked: false,
      idReturo: item.idReturo,
      shopCode: item.shopCode,
  }))
